import React from 'react';
import AppRoutes from './routes';
import { ThemeProvider } from './contexts/ThemeContext';

/**
 * Корневой компонент приложения
 */
const App = () => {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;